import { useEffect, useState } from 'react';

import create from 'zustand';
import cloneDeep from 'lodash/cloneDeep';

type Status = 'none' | 'in-progress' | 'ready' | 'error';
type ImageStatusType = 'none' | 'uploading' | 'dalle-generating' | 'ready' | 'error' | 'dalle-failed';

type StatusType = ImageStatusType;

type BlockStatus = {
  status: Status;
  statusType: StatusType;
}

const defaultBlockStatus = {
  status: 'none',
  statusType: 'none',
} as BlockStatus;

type StateVars = {
  // create map of blockId to blockStatus
  blockStatuses: Record<string, BlockStatus>;
  defaultBlockStatus: BlockStatus;
}

type StatFns = {
  setBlockStatus: (blockId: string, status: BlockStatus) => void;
  getBlockStatus: (blockId: string) => BlockStatus;
  hasBlockStatus: (blockId: string) => boolean;
  resetBlockStatus: (blockId: string) => void;
  resetBlockStatuses: () => void;
}

type State = StateVars & StatFns;

const initialState: StateVars = {
  blockStatuses: {},
  defaultBlockStatus: defaultBlockStatus,
};

export const useBlockStatusesStore = create<State>((set, get) => ({
  ...initialState,
  setBlockStatus: (blockId: string, status: BlockStatus) => {
    set((state) => {
      state.blockStatuses[blockId] = cloneDeep(status);
    });
  },
  hasBlockStatus: (blockId: string) => {
    const blockStatuses = get().blockStatuses;
    return !!blockStatuses[blockId];
  },
  getBlockStatus: (blockId: string) => {
    const blockStatuses = get().blockStatuses;
    if (!blockStatuses[blockId]) return defaultBlockStatus;
      
    return blockStatuses[blockId];
  },
  resetBlockStatus: (blockId: string) => {
    set((state) => {
      state.blockStatuses[blockId] = {
        status: 'none',
        statusType: 'none',
      }
    });
  },
  resetBlockStatuses: () => {
    set((state) => {
      state.blockStatuses = {};
    });
  }
}));